var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatsu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8_86_7",
    "data-name": "\\u30B3\\u30F3\\u30DD\\u30FC\\u30CD\\u30F3\\u30C8 86 \\u2013 7",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9577\\u65B9\\u5F62_13346",
    "data-name": "\\u9577\\u65B9\\u5F62 13346",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_220",
    "data-name": "\\u30D1\\u30B9 220",
    d: "M154.084,377.49l9.793-9.793a1.879,1.879,0,0,0,0-2.657,1.923,1.923,0,0,0-2.657,0l-9.793,9.793-9.792-9.793a1.922,1.922,0,0,0-2.657,0,1.877,1.877,0,0,0,0,2.657l9.792,9.793-9.792,9.792a1.88,1.88,0,0,0,0,2.657,1.922,1.922,0,0,0,2.657,0l9.792-9.793,9.793,9.792a1.878,1.878,0,0,0,2.657,0,1.883,1.883,0,0,0,0-2.657Z",
    transform: "translate(-135.427 -361.508)",
    fill: "#41619a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatsu);
export default __webpack_public_path__ + "static/media/batsu.dfb2af83f6da709435aba84b87e32ce0.svg";
export { ForwardRef as ReactComponent };